module.exports = require('./lib/speakingurl');
